/* ⚛ REACT */
import React from "react";

/* 📦 LIBS */
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { Button, CloseIcon } from "../../../../Components"

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContentContainer, ChildsContainer} from "./styles"

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

const ModalMap = (props) => {

    const { isOpen } = useTour();

    let childs = React.Children.toArray(props.children);
    let active = useSelector(state => state.ModalReducer.name) === props.name;

    const height = isValidaProp(props.height) ? props.height : '50%';
    const width = isValidaProp(props.width) ? props.width : '50%';

    const handleClickClose = (event) => {
        if (!event?.isTrusted || !isOpen) {
            store.dispatch(changeModal(null));
        }
    }

    return(
        <Container $Active={active}>
            <ContentContainer id={props.id} $width={width} $height={height}>
                    <Button 
                    color={"white-green"} 
                    onClick={(e) => handleClickClose(e)} 
                    icon={<CloseIcon fill={"#006560"}/>} 
                    padding={"0"} 
                    position={"absolute"} 
                    radius={"50%"} 
                    height={"44px"} 
                    width={"44px"}
                    />
                    <TitleContainer $background={props.$background}>
                        <Title $background={props.$background}>{props.title}</Title>
                    </TitleContainer>

                    <ChildsContainer>
                        {childs.map((child, index) => {
                            if(index % 2 === 0){
                                let newProps = {
                                    ...child.props,
                                    $background: '#fff',
                                };
                                return React.cloneElement(child, newProps);
                            }
                            return (child)
                        })}
                    </ChildsContainer>
            </ContentContainer>
        </Container>
    )
}

export default ModalMap;